// tslint:disable: no-any
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpHeaders
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { AuthService } from '@core/auth/auth.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private authService: AuthService) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const reqModified = request.clone({ headers: this.setAuthHeader() });

    // Skip interceptor if url request contains auth
    if (request.url.includes('auth')) {
      return next.handle(request);
    }

    return next.handle(reqModified);
  }

  private setAuthHeader() {
    const authToken = this.authService.getToken();
    let headers = new HttpHeaders();

    if (this.authService.isLoggedIn()) {
      headers = headers.append('authorization', 'Bearer ' + authToken);
    }

    return headers;
  }
}
